import Vue from 'vue';
import Vuex from 'vuex';
import * as bank from './bank';
import * as coins from './coins';
import * as transaction from './transaction';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  modules: {
    bank,
    coins,
    transaction,
  },
});
